// common
export const RESET_STATE = 'reset'

// --
export const PUSH = 'push'
export const DISMISS = 'dismiss'
export const DISMISS_ALL = 'dismissAll'
